import script from "./CallRecordList.vue?vue&type=script&setup=true&lang=js"
export * from "./CallRecordList.vue?vue&type=script&setup=true&lang=js"

import "./CallRecordList.vue?vue&type=style&index=0&id=4be31a1b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4be31a1b"]])

export default __exports__